/**
 * Security utilities for the frontend
 */

/**
 * Hashes a string using SHA-256 to obfuscate it in transit (Network tab).
 * Note: This is an additional layer of obfuscation. Primary security is SSL/TLS (HTTPS).
 * @param {string} string - The string to hash (e.g., password)
 * @returns {Promise<string>} - The hex representation of the hash
 */
export const hashString = async (string) => {
    if (!string) return '';
    
    try {
        const msgUint8 = new TextEncoder().encode(string);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
    } catch (error) {
        console.error('Hashing failed:', error);
        return string; // Fallback to plain if crypto is not available
    }
};
